export default __webpack_public_path__ + "static/media/affordable.249a1097.svg";